import { ActivatedRouteSnapshot, CanActivateFn, Router } from '@angular/router';
import { RouteData } from '@constants/enum';
import { inject } from '@angular/core';

/**
 * Guard to check if the action type is allowed for the route.
 * If not, redirect to route without action type.
 * Action types must be defined in the route data as [RouteData.PropActionTypes]: ["action1", ...] to be checked.
 */
export const actionTypeGuard: CanActivateFn = (route: ActivatedRouteSnapshot) => {
  const router = inject(Router);

  if (Array.isArray(route.data?.[RouteData.PropActionTypes])) {
    const allowedTypes = route.data[RouteData.PropActionTypes] as string[];

    return allowedTypes.includes(route.params?.type ?? '')
      ? true
      : router.createUrlTree([route.url[0].toString()]); // redirect to route without action type
  }

  return true;
};
